export default {
  updateBizoppDetailBasicInfo(state, data) {
    state.basicBizoppInfo = data
  },
  updateBizoppButtonGroup(state, data) {
    state.bizoppButtonGroup = data
  },
  updateSignFailedReasonList(state, data) {
    state.signFailedReasonList = data
  },
  updateBizoppAllInfo(state, data) {
    state.allBizoppInfo = data
  },
  updateTipCurRef(state, data) {
    state.tipCurRef = data
  },
  updateBusinessInfo(state, data) {
    state.businessInfo = data
  },
  updateSurveyInfo(state, data) {
    state.surveyInfo = data
  },
  updateCurTabLabel(state, data) {
    state.curTabLabel = data
  },
  // 撤销申请的弹窗显隐控制
  toggleBackoutApply(state, data) {
    state.backoutApply = data
  },
  // 签约需要用到的TYPE
  updateBizoppType(state, data) {
    state.type = data
  },
  // 控制签约需要选择的弹窗
  toggleShowPicker(state, payload) {
    state.showPicker = payload
  },
  // 清除缓存数据
  clearCache(state, payload) {
    const obj = {}
    const { shopId } = payload
    obj[shopId] = {}
    // state.contractorDetail = Object.assign(state.contractorDetail, obj)
    // state.shopBaseDetail = Object.assign(state.shopBaseDetail, obj)
    // state.allConfig = Object.assign(state.allConfig, obj)
    // state.bizoppDetail = Object.assign(state.bizoppDetail, obj)
  },
  // 已签章提示
}
